import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'happy-input-template',
    templateUrl: './happy-input-template.component.html',
    styleUrls: ['./happy-input-template.component.css', '../styles.css'],
})
export class HappyInputTemplateComponent {

    @Input() controlName: string;
    @Input() form: FormGroup;
    @Input() required = true;

    constructor() {
    }

    get hasError() {
        const { form, controlName } = this;
        const control = form && form.controls[controlName];
        return control && control.errors && control.touched && control.dirty;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-template-input/happy-input-template.component.ts